import env from '../utils/env';
import nativeApi from '../utils/nativeApi';
import {
  showPicker,
  hidePicker,
  showLoading,
  hideLoading,
  showPopup,
  hidePopup,
  showNotification,
  hideNotification,
  showOptions,
  hideOptions,
  showFullLoading,
  hideFullLoading
} from './base';

function updateTitle(title) {
  // 南航等第三方需要改变title的情况,以下为映射，按照索引一一对应
    /**
     * ptid    title     第三方合作商
     * sa    预订高铁票    南航
    */
   let vNeedChangeTitleSource = [ 'sa' ];
   let vNeedChangeTitleMap =    [ '预订高铁票' ];
   let vPtidStr = window.location.search;
   if (vPtidStr.indexOf('?') >= 0) {
    let reg = new RegExp("(^|&)ptid=([^&]*)(&|$)", "i"); //定义正则表达式 
    let r = vPtidStr.substr(1).match(reg);  
     if (r != null) {
       vPtidStr = r[2];
     }
   }
   let lTitle = '高铁管家';
   if (vNeedChangeTitleSource.indexOf(vPtidStr) >=0 ) {
    lTitle = vNeedChangeTitleMap[ vNeedChangeTitleSource.indexOf(vPtidStr) ];
   }
   // 只有首页给替换title，其他页面保持不变
   if (window.location.href.indexOf('ticketAgent/home') >= 0) {
    title = lTitle;
   }

  document.title = title;
  if (env.isNative) {
    nativeApi.invoke('updateTitle', {
      text: title
    });
  }
}

function withLoading(fn, { title } = { title: '' }) {
  return (...args) => {
    showLoading({ title });
    return fn(...args).then(r => {
      hideLoading();
      return r;
    }, e => {
      hideLoading();
      throw e;
    });
  };
}

function withFullLoading(fn, { title } = { title: '' }){
  return (...args) => {
    showFullLoading({ title });
    return fn(...args).then(r => {
      hideFullLoading();
      return r;
    }, e => {
      hideFullLoading();
      throw e;
    });
  };
}

export default {
  showPicker,
  hidePicker,
  showOptions,
  hideOptions,
  showLoading,
  hideLoading,
  showPopup,
  hidePopup,
  showNotification,
  hideNotification,
  updateTitle,
  withLoading,
  withFullLoading
};



// WEBPACK FOOTER //
// ./src/ui/index.js